export default __webpack_public_path__ + "static/media/food-logo.d6f4e2f7.jpg";